"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const AttentionFilledXsmall_1 = require("@nbc-design/icons/lib/web/AttentionFilledXsmall");
const FailureFilledXsmall_1 = require("@nbc-design/icons/lib/web/FailureFilledXsmall");
const InformationFilledXsmall_1 = require("@nbc-design/icons/lib/web/InformationFilledXsmall");
const SuccessFilledXsmall_1 = require("@nbc-design/icons/lib/web/SuccessFilledXsmall");
require("./message.css");
/** Messages are used in form validation to display an error, or a warning. It can also be used in interactive interfaces to display a status. */
const Message = ({ children, id, className, appearance = 'information', ...other }) => {
    const iconsProp = {
        className: 'dsc-message__icon',
        size: 'xsmall',
    };
    const getStatus = (type) => {
        const status = {
            information: () => {
                return {
                    dataTest: 'information-message',
                    icon: (0, jsx_runtime_1.jsx)(InformationFilledXsmall_1.InformationFilledXsmall, { ...iconsProp }),
                    class: 'dsc-message--information',
                };
            },
            error: () => {
                return {
                    dataTest: 'error-message',
                    icon: (0, jsx_runtime_1.jsx)(FailureFilledXsmall_1.FailureFilledXsmall, { ...iconsProp }),
                    class: 'dsc-message--error',
                };
            },
            success: () => {
                return {
                    dataTest: 'success-message',
                    icon: (0, jsx_runtime_1.jsx)(SuccessFilledXsmall_1.SuccessFilledXsmall, { ...iconsProp }),
                    class: 'dsc-message--success',
                };
            },
            warning: () => {
                return {
                    dataTest: 'warning-message',
                    icon: (0, jsx_runtime_1.jsx)(AttentionFilledXsmall_1.AttentionFilledXsmall, { ...iconsProp }),
                    class: 'dsc-message--warning',
                };
            },
            inactive: () => {
                return {
                    dataTest: 'inactive-message',
                    icon: (0, jsx_runtime_1.jsx)("div", { className: "dsc-message__icon dsc-message__icon--inactive" }),
                    class: 'dsc-message--inactive',
                };
            },
        };
        return status[type]() || status[appearance];
    };
    const message = getStatus(appearance);
    const classes = (0, classnames_1.default)('dsc-message', message.class, className);
    return ((0, jsx_runtime_1.jsxs)("span", { ...other, id: id, className: classes, "data-test": message.dataTest, "aria-live": "assertive", children: [message.icon, children] }));
};
exports.Message = Message;
exports.Message.displayName = 'Message';
//# sourceMappingURL=message.js.map